import type { MarketVariants } from '@/lib/i18n'

export type Slide5BridgeCopy = {
  title: string
  body: string
}

export const copy: MarketVariants<Slide5BridgeCopy> = {
  US: {
    title: 'Verify It Yourself',
    body:
      'Once your head is clear, check the situation through a path you already trust. Never use the link, phone number, or instructions they gave you.',
  },
  ar: {
    title: 'تحقّق بنفسك',
    body:
      'عندما يصفو ذهنك، تحقّق من الموقف عبر قناة تثق بها مسبقاً. لا تستخدم أبداً الرابط أو رقم الهاتف أو التعليمات التي أعطوك إياها.',
  },
}
